import { ss_fm_Location_retrieveAll_filter, ss_fm_Location_retrieveAll_order } from '../../../services/api/api';
import { SbLocationListColumn } from '../../../services/global/global-interfaces';

export const clientColumnDefaultsLocations: Record<string, SbLocationListColumn[]> = {
  pmg: [
    // SELECTED START
    {
      id: 'id',
      title: 'ID',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.ID,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.ID,
      canFilter: true,
    },
    {
      id: 'name',
      title: 'name',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.NAME,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.NAME,
      canFilter: true,
    },
    { id: 'address', title: 'Address', selected: true, type: 'PROPERTY' },
    { id: 'CustStatus', title: 'CustStatus', selected: true, type: 'COMPANY_ATTRIBUTE' },
    { id: 'CustSapKeyOfn', title: 'SAP-CustNr', selected: true, type: 'COMPANY_ATTRIBUTE' },
    { id: 'CustName', title: 'CustName', selected: true, type: 'COMPANY_ATTRIBUTE' },
    {
      id: 'address.city',
      title: 'address.city',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.CITY,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.CITY,
      canFilter: true,
    },
    {
      id: 'address.street',
      title: 'address.street',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.STREET,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.STREET,
      canFilter: true,
    },
    {
      id: 'ParentCustSapKey',
      title: 'SAP-ParentCustNr',
      selected: true,

      type: 'COMPANY_ATTRIBUTE',
    },
    {
      id: 'ParentCustName',
      title: 'SAP-ParentCustName',
      selected: true,

      type: 'COMPANY_ATTRIBUTE',
    },
    // SELECTED END
    {
      id: 'created',
      title: 'created',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.CREATED_AT,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.CREATED_AT,
      canFilter: true,
    },
    {
      id: 'identifier',
      title: 'lang.globals.identifier',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.IDENTIFIER,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.IDENTIFIER,
      canFilter: true,
    },
    {
      id: 'address.borough',
      title: 'address.borough',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.BOROUGH,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.BOROUGH,
      canFilter: true,
    },
    {
      id: 'address.country',
      title: 'address.country',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.COUNTRY,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.COUNTRY,
      canFilter: true,
    },
    {
      id: 'address.county',
      title: 'address.county',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.COUNTY,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.COUNTY,
      canFilter: true,
    },
    {
      id: 'address.state',
      title: 'address.state',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.STATE,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.STATE,
      canFilter: true,
    },
    {
      id: 'address.street2',
      title: 'address.street2',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.STREET2,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.STREET2,
      canFilter: true,
    },
    {
      id: 'address.zip',
      title: 'address.zip',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.ZIP,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.ZIP,
      canFilter: true,
    },
    {
      id: 'managedBy.name',
      title: 'managedBy.name',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.MANAGED_BY_NAME,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.MANAGED_BY_NAME,
      canFilter: true,
    },
    {
      id: 'managedBy.created',
      title: 'managedBy.created',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.MANAGED_BY_CREATED_AT,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.MANAGED_BY_CREATED_AT,
      canFilter: true,
    },
    {
      id: 'managedBy.identifier',
      title: 'managedBy.identifier',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.MANAGED_BY_IDENTIFIER,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.MANAGED_BY_IDENTIFIER,
      canFilter: true,
    },
    {
      id: 'managedBy.address.borough',
      title: 'managedBy.address.borough',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.MANAGED_BY_BOROUGH,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.MANAGED_BY_BOROUGH,
      canFilter: true,
    },
    {
      id: 'managedBy.address.city',
      title: 'managedBy.address.city',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.MANAGED_BY_CITY,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.MANAGED_BY_CITY,
      canFilter: true,
    },
    {
      id: 'managedBy.address.country',
      title: 'managedBy.address.country',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.MANAGED_BY_CITY,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.MANAGED_BY_CITY,
      canFilter: true,
    },
    {
      id: 'managedBy.address.county',
      title: 'managedBy.address.county',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.MANAGED_BY_COUNTY,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.MANAGED_BY_COUNTY,
      canFilter: true,
    },
    {
      id: 'managedBy.address.state',
      title: 'managedBy.address.state',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.MANAGED_BY_STATE,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.MANAGED_BY_STATE,
      canFilter: true,
    },
    {
      id: 'managedBy.address.street',
      title: 'managedBy.address.street',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.MANAGED_BY_STREET,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.MANAGED_BY_STREET,
      canFilter: true,
    },
    {
      id: 'managedBy.address.street2',
      title: 'managedBy.address.street2',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.MANAGED_BY_STREET2,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.MANAGED_BY_STREET2,
      canFilter: true,
    },
    {
      id: 'managedBy.address.zip',
      title: 'managedBy.address.zip',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.MANAGED_BY_ZIP,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.MANAGED_BY_ZIP,
      canFilter: true,
    },
    { id: 'managedBy.address', title: 'managedBy.address', selected: false, type: 'PROPERTY' },
  ],
  generic: [
    {
      id: 'id',
      title: 'ID',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.ID,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.ID,
      canFilter: true,
    },
    {
      id: 'name',
      title: 'name',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.NAME,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.NAME,
      canFilter: true,
    },
    {
      id: 'created',
      title: 'created',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.CREATED_AT,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.CREATED_AT,
      canFilter: true,
    },
    {
      id: 'identifier',
      title: 'lang.globals.identifier',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.IDENTIFIER,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.IDENTIFIER,
      canFilter: true,
    },
    {
      id: 'address.borough',
      title: 'address.borough',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.BOROUGH,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.BOROUGH,
      canFilter: true,
    },
    {
      id: 'address.city',
      title: 'address.city',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.CITY,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.CITY,
      canFilter: true,
    },
    {
      id: 'address.country',
      title: 'address.country',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.COUNTRY,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.COUNTRY,
      canFilter: true,
    },
    {
      id: 'address.county',
      title: 'address.county',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.COUNTY,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.COUNTY,
      canFilter: true,
    },
    {
      id: 'address.state',
      title: 'address.state',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.STATE,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.STATE,
      canFilter: true,
    },
    {
      id: 'address.street',
      title: 'address.street',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.STREET,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.STREET,
      canFilter: true,
    },
    {
      id: 'address.street2',
      title: 'address.street2',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.STREET2,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.STREET2,
      canFilter: true,
    },
    {
      id: 'address.zip',
      title: 'address.zip',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.ZIP,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.ZIP,
      canFilter: true,
    },
    { id: 'address', title: 'Address', selected: true, type: 'PROPERTY' },
    {
      id: 'managedBy.name',
      title: 'managedBy.name',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.MANAGED_BY_NAME,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.MANAGED_BY_NAME,
      canFilter: true,
    },
    {
      id: 'managedBy.created',
      title: 'managedBy.created',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.MANAGED_BY_CREATED_AT,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.MANAGED_BY_CREATED_AT,
      canFilter: true,
    },
    {
      id: 'managedBy.identifier',
      title: 'managedBy.identifier',
      selected: true,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.MANAGED_BY_IDENTIFIER,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.MANAGED_BY_IDENTIFIER,
      canFilter: true,
    },
    {
      id: 'managedBy.address.borough',
      title: 'managedBy.address.borough',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.MANAGED_BY_BOROUGH,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.MANAGED_BY_BOROUGH,
      canFilter: true,
    },
    {
      id: 'managedBy.address.city',
      title: 'managedBy.address.city',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.MANAGED_BY_CITY,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.MANAGED_BY_CITY,
      canFilter: true,
    },
    {
      id: 'managedBy.address.country',
      title: 'managedBy.address.country',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.MANAGED_BY_CITY,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.MANAGED_BY_CITY,
      canFilter: true,
    },
    {
      id: 'managedBy.address.county',
      title: 'managedBy.address.county',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.MANAGED_BY_COUNTY,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.MANAGED_BY_COUNTY,
      canFilter: true,
    },
    {
      id: 'managedBy.address.state',
      title: 'managedBy.address.state',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.MANAGED_BY_STATE,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.MANAGED_BY_STATE,
      canFilter: true,
    },
    {
      id: 'managedBy.address.street',
      title: 'managedBy.address.street',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.MANAGED_BY_STREET,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.MANAGED_BY_STREET,
      canFilter: true,
    },
    {
      id: 'managedBy.address.street2',
      title: 'managedBy.address.street2',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.MANAGED_BY_STREET2,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.MANAGED_BY_STREET2,
      canFilter: true,
    },
    {
      id: 'managedBy.address.zip',
      title: 'managedBy.address.zip',
      selected: false,

      type: 'PROPERTY',
      orderId: ss_fm_Location_retrieveAll_order.MANAGED_BY_ZIP,
      canOrder: true,
      filterId: ss_fm_Location_retrieveAll_filter.MANAGED_BY_ZIP,
      canFilter: true,
    },
    { id: 'managedBy.address', title: 'managedBy.address', selected: false, type: 'PROPERTY' },
  ],
};
